module.exports = __webpack_public_path__ + "static/media/salesforce.e9a1a70d.png";